import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import {
  mdiDownload, mdiDownloadOutline, mdiBriefcaseDownload, mdiBriefcaseDownloadOutline,
} from '@mdi/js';
import cx from 'classnames';

import analytics from '../../helpers/analytics';

import c from './DownloadButton.less';

export function DownloadTrackButton(props) {
  const {
    url, className, fileSize, wasDownloaded, ariaLabel,
  } = props;
  const handleClick = () => {
    analytics.trackEvent({ action: 'Download', label: 'Track', value: fileSize });
  };

  return (
    <a href={url} className={className} onClickCapture={handleClick} aria-label={ariaLabel}>
      <Icon path={wasDownloaded ? mdiDownload : mdiDownloadOutline} size={1} className={c.dowloadIcon} />
    </a>
  );
}

DownloadTrackButton.propTypes = {
  url: PropTypes.string.isRequired,
  fileSize: PropTypes.number,
  wasDownloaded: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

DownloadTrackButton.defaultProps = {
  fileSize: 0,
  wasDownloaded: false,
  ariaLabel: '',
};

export function DownloadReleaseButton(props) {
  const {
    url, className, fileSize, wasDownloaded, ariaLabel,
  } = props;
  const handleClick = () => {
    analytics.trackEvent({ action: 'Download', label: 'Release', value: fileSize });
  };

  return (
    <a href={url} className={cx(className, c.downloadReleaseLink)} onClickCapture={handleClick} aria-label={ariaLabel}>
      <Icon path={wasDownloaded ? mdiBriefcaseDownload : mdiBriefcaseDownloadOutline} size={1} className={c.dowloadIcon} />
    </a>
  );
}

DownloadReleaseButton.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
  fileSize: PropTypes.number,
  wasDownloaded: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

DownloadReleaseButton.defaultProps = {
  className: '',
  url: '',
  fileSize: 1000,
  wasDownloaded: false,
  ariaLabel: '',
};
